import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import App from './App';
import * as serviceWorker from './serviceWorker';

Sentry.init({
  dsn: 'https://8c6e0983c6bc4c48858a13005d816e18@o351335.ingest.sentry.io/5589134',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

if (window.location.href.includes('localhost')) {
  window.leadboxData = {
    s: 'd8ce4b942c9c0c8c7f5e298c045b8d37',
    fields: [
      ['d60403ae4f0e270fd8faf0ea30244adb', 't', null, 1246622602, null, 'form'],
      ['84b762446986cc8abd5f5e0afbc1f800', 'aux_url', null, 'http://localhost/?config=a-kasse-nu', null, 'system'],
      ['3c90464ce70e718d1dbe5ca519b4032e', 'aux_lang', null, 'NO', null, 'form'],
      ['6995ba6fae445542a18dee9e98c7e28e', 'aux_avsender', null, 'hus.no', null, 'form'],
      ['e8ea8afbc19af1365b410a6ac2114295', 'sys_nature', null, '17', null, 'system'],
      ['bbe8ec695b4f095cbdb42d89a9793704', 'honeypot', null, '', null, 'form'],
      ['411cd83d66026cd0851d4d8471ee8b0b', 'h1_behov', null, 'Behov', null, 'form'],
      [
        '251189abadc6414d3631293a7ebbbd3e',
        'general_needs',
        'Hvad ønsker du tilbud på?',
        ['A-kasse'],
        'A-kasse',
        'form',
      ],
      [
        '036806f3de2c99ab53fea9e6bc1082df',
        'union_membership',
        'Ønsker du også fagforeningsmedlemskab?',
        ['true'],
        'Ja',
        'form',
      ],
      ['c5e06cefb6a7733cd0f47c326adb4f00', 'h1_andre_behov', null, 'Andre behov', null, 'form'],
      [
        'a4c1cae363c4273fe102e44abb1b38ce',
        'early_retirement_scheme',
        'Ønsker du efterlønsordning?',
        ['Ja'],
        'Ja',
        'form',
      ],
      [
        '0de624d5255b32cdc5a1a25f53177f99',
        'insurance_coverage',
        'Ønsker du fuldtidsforsikring eller deltidsforsikring?',
        ['Fuldtid'],
        'Fuldtid',
        'form',
      ],
      [
        'a00ff69669f877cb447c3302af86bbd7',
        'employment_type',
        'Hvad er din arbejdssituation?',
        'Lønmodtager',
        'Lønmodtager',
        'form',
      ],
      [
        '263b1714b76752e8b393932205ca2f9e',
        'profession_industry',
        'Branche',
        'Handel, salg og service',
        'Handel, salg og service',
        'form',
      ],
      ['0d354e3d1d55cf329e5f8b7f0d44b0c5', 'h1_nuværende_a-kasse', null, 'Nuværende a-kasse', null, 'form'],
      [
        '5317fcad653bfca41e3befb8c1962b27',
        'current_supplier',
        'Nuværende a-kasse',
        'A-kassen Lederne',
        'A-kassen Lederne',
        'form',
      ],
      ['1e044436cc5c262a0365d67832e0b062', 'h1_kontakt', null, 'Kontaktinformation', null, 'form'],
      ['40d4a7739924e6a8f58aa4a52abc293f', 'first_name', 'Fornavn', 'Espen', null, 'form'],
      ['07f2074a5a3b4139ff089455301ff861', 'last_name', 'Efternavn', 'holden test', null, 'form'],
      ['843fd9b8058cbb3fc439a55ac197561b', 'name', null, 'Espen holden', null, 'form'],
      ['0b8ecacfa050b9cfc15c15b0596cf2eb', 'h1_kundetype', null, 'Kundetype', null, 'form'],
      [
        '197d2a78ba55cf20e187dc6638f64d4a',
        'study_degree',
        'Hvad er din længste færdiggjorte uddannelse?',
        'Erhvervsakademiuddannelse',
        'Erhvervsakademiuddannelse',
        'form',
      ],
      ['08eee25763b852380983f464358fc658', 'email', 'email-label', 'thomas@tholden.no', null, 'form'],
      ['4534772fd4baef01239f07fface58dec', 'email_canonical', null, 'thomas@tholden.no', null, 'generated'],
      ['cb774eefbaddba77f98c3d07586ef824', 'email_unicode', null, 'thomas@tholden.no', null, 'generated'],
      ['566e79e0b8411011e80501f6703951ed', 'email_mx', null, true, null, 'generated'],
      ['1744b50fd622c30f90ddc9b5bac16fa6', 'email_smtp', null, true, null, 'generated'],
      ['fc432f678a7b3682121aff4303ba9b46', 'phone', 'Telefon', '94845308', null, 'form'],
      ['dfb8c8bf7a8b74574ba177ea5546f62c', 'phone_local_format', null, '94 84 53 08', null, 'generated'],
      ['0c7bad27a2585be251b861a6e75a2d78', 'phone_international_format', null, '+4594845308', null, 'generated'],
      ['e4e96e5c693aee8739f914dc09868019', 'phone_country', null, 'DK', null, 'generated'],
      ['27d27dce961a10339c35350c99d3eb65', 'birthdate', 'Fødselsdato (seks cifre)', '180192', null, 'form'],
      ['df31928a583c37e18d4b44f733a75baa', 'h1_address', null, 'Adresse', null, 'form'],
      ['c7d9d67fd3d8468b9cbd4e17edf58bb6', 'address', 'Adresse', 'Finnedalsvej 2', null, 'form'],
      ['a662e9ef9dd57f669953a5fde0888f14', 'address_street_number', null, '2', null, 'generated'],
      ['9ca84242a23150ee9130633acb955d90', 'address_street_name', null, 'Finnedalsvej', null, 'generated'],
      ['da5963d369db6de792c28c137cacb368', 'address_zip', null, '9999', null, 'generated'],
      ['3e152dae27276adbc7836adeb253dffd', 'zip', null, '9999', null, 'form'],
      ['2603cf311e8cf24cec5dd1bda78f4e2a', 'h1_andet', null, 'Andet', null, 'form'],
      [
        'bf49739c260edf93ef3d32a9bef94ea7',
        'accept_terms',
        'Jeg bekræfter hermed, at jeg er over 18 år og giver samtykke til, at op til tre a-kasser må kontakte mig via e-mail, telefon og/eller SMS med gode tilbud på enten a-kasse, lønsikring og/eller fagforening baseret på mine valg i formularen.',
        'true',
        null,
        'form',
      ],
    ],
  };
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
